// host-configurable via hostSettings.gangSheet.maxTotalCopies; this is the fallback cap
export const DEFAULT_MAX_TOTAL_COPIES = 500;

export const MIN_GAP_MM = 0;
export const MAX_GAP_MM = 20;

// nested pieces are either kept upright or turned by a quarter — nestOnSheet only
// distinguishes rotated/not rotated
export const GANG_SHEET_ROTATION_DEG = 90;

// new artwork lands on the sheet at its physical size at this print resolution (unless
// the host overrides it via hostSettings.gangSheet.defaultImageDpi)
export const GANG_SHEET_DEFAULT_IMAGE_DPI = 300;
